import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_HEADER_CLASS_NAME = 'TableHeader';

export const TABLE_HEADER_CLASS_SLOTS = ['root'] as const;

export type TableHeaderClassSlot = (typeof TABLE_HEADER_CLASS_SLOTS)[number];

export interface TableHeaderClasses {
	root: string;
}

export type TableHeaderClassKey = keyof TableHeaderClasses;

export const getTableHeaderUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_HEADER_CLASS_NAME, slot);

export const tableHeaderClasses = generateUtilityClasses<
	keyof TableHeaderClasses
>(TABLE_HEADER_CLASS_NAME, ['root']);
export default tableHeaderClasses;
